import AjaxUtils from "../../../util/ajax_utils";
import {ApckPortletApexChart} from "../portlet";

export const ApckPortletTracker = /*#__PURE__*/ ApckPortletApexChart.extend({
    props: {
        ctype: {
            type: String,
            default: "trackerportlet"
        },
        title: {
            type: String,
            default: "Vulnerability Tracker"
        },
        size: {
            type: String,
            default: "md"
        },
        description: {
            type: String,
            default: "A tracker chart that shows the vulnerabilities impact discovered over time"
        },
        src: {
            type: String,
            default: "/tracker"
        },
        chartType: {
            type: String,
            default: 'line',
        },
        defaultChartOptions: {
            type: Object,
            default: function () {
                return {
                    stroke: {
                        curve: 'smooth',
                    },
                    xaxis: {
                        categories: [],
                    },
                    yaxis: {
                        tickAmount: 1,
                        min: 0,
                        forceNiceScale: true,
                        labels: {
                            formatter: function (val) {
                                return val.toFixed(0);
                            }
                        }
                    },
                    dataLabels: {
                        enabled: true,
                    },
                    chart: {
                        toolbar: {
                            show: true,
                            offsetX: 0,
                            offsetY: 0,
                            tools: {
                                download: false,
                                selection: false,
                                zoom: false,
                                zoomin: false,
                                zoomout: false,
                                pan: false,
                                reset: false,
                            },
                        },
                    },
                    grid: {
                        xaxis: {
                            lines: {
                                show: true
                            }
                        },
                        yaxis: {
                            lines: {
                                show: true
                            }
                        },
                    },
                    states: {
                        active: {
                            filter: {
                                type: 'none'
                            }
                        },
                        hover: {
                            filter: {
                                type: 'none',
                            }
                        },
                    },
                }
            }
        },
    },
    methods: {
        parseData: function (data) {
            this.chartSeries = data.datasets;
            this.chartOptions['yaxis']['max'] = Math.max(10, ...data.datasets.flatMap(obj => obj.data));
            this.chartOptions['xaxis']['categories'] = data.labels;
            this.chartOptions['colors'] = data.colors;

            this.$refs.portletChart.updateSeries(this.chartSeries);
            this.$refs.portletChart.updateOptions(this.chartOptions);
        },
    },
    created() {
        const cmp = this;
        if (cmp.options.scan.value === 'All') {
            cmp.options.scan.value = null;
        }
        AjaxUtils.ajax_get({
            url: "/scans/idnamelist/idnamelist",
            success: function (scans) {
                for (const scan of scans) {
                    cmp.$data.options.scan.choices.push({value: scan.id, label: scan.name});
                }
            },
        });
    },
    data: function () {
        return {
            options: {
                mode: {
                    label: "Mode",
                    type: "select",
                    default: "all",
                    choices: [{
                        label: "All vulnerabilities",
                        value: "all"
                    }, {
                        label: "Unfixed vulnerabilities",
                        value: "unfixed"
                    }]
                },
                scan_filter: {
                    label: "Scan Filter",
                    type: "select",
                    default: "completed_only",
                    choices: [{
                        label: "Completed only",
                        value: "completed_only"
                    }, {
                        label: "All",
                        value: "all"
                    }]
                },
                count: {
                    label: "Result Count",
                    type: "number",
                    default: 5,
                },
                scan: {
                    label: "Scan",
                    type: "select",
                    default: null,
                    choices: [{
                        label: "All", value: null
                    }]
                }
            }
        };
    },
});
